/*
 * Application Insights JavaScript SDK - Core, 2.7.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
"use strict";
export var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map